/**
 * Compact `YYYYMMDDHHmmss` timestamp used to suffix auto-generated
 * workflow app names (create + clone flows).
 */
export function formatDatetime(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return (
    String(d.getFullYear()) +
    p(d.getMonth() + 1) +
    p(d.getDate()) +
    p(d.getHours()) +
    p(d.getMinutes()) +
    p(d.getSeconds())
  );
}
